module.exports = __webpack_public_path__ + "static/certyfikat_WSK_niem-78dd2c247b5873a0b0a40b636718e3c2.pdf";